export const serializeDate = (date: Date): string => {
  let result = date.toISOString();
  result = result.replace('T', ' ');
  result = result.replace('Z', '');
  return result;
};
